<template>
	<div data-tour-scope="shipping-costs">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.shipmentcost') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi costo di spedizione" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12">
									<v-alert outlined text type="info" data-tour="notice"
										>Per duplicare, modificare o eliminare in blocco un listino, scegli nei filtri un solo metodo di spedizione e un solo paese
									</v-alert>
								</v-col>
							</v-row>
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-autocomplete
										v-model="settings.filters.methods"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										:items="methods"
										label="Metodi di spedizione"
										item-value="_id"
										multiple
										item-text="trans.name"
										clearable
										dense
										outlined
										hide-details
									></v-autocomplete>
								</v-col>
								<v-col cols="12" md="3">
									<v-autocomplete
										v-model="settings.filters.country"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										:items="codes"
										label="Country"
										item-value="alpha-2"
										item-text="name"
										multiple
										chips
										deletable-chips
										clearable
										dense
										outlined
										hide-details
									>
									</v-autocomplete>
								</v-col>

								<v-col v-if="massivo" cols="12" md="6" data-tour="bulk">
									<v-chip color="primary" @click="duplica()">Duplica</v-chip>
									<v-chip class="ml-1" color="primary" @click="editcomplete()">Modifica</v-chip>
									<v-chip class="ml-1" color="error" @click="elimina()">Elimina</v-chip>
								</v-col>
							</v-row>
						</v-col>
						<v-layout wrap data-tour="test">
							<v-flex xs12 sm4 class="pa-4">
								<v-text-field label="Test spedizione. Inserisci indirizzo " class="mt-0" outlined dense hide-details v-model="formtest.address"></v-text-field>
							</v-flex>
							<v-flex xs12 sm4 class="pa-4">
								<v-btn color="primary" @click="tastAddress()"> Cerca </v-btn>
							</v-flex>
						</v-layout>
						<v-layout wrap v-if="formtest.map.place_id">
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Nome" class="mt-0" v-model="formtest.map.nome"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Località" class="mt-0" v-model="formtest.map.locality"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Comune" class="mt-0" v-model="formtest.map.comune"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Via" class="mt-0" v-model="formtest.map.route"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Numero civico" class="mt-0" v-model="formtest.map.street_number"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Cap" class="mt-0" v-model="formtest.map.postal_code"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Provincia" class="mt-0" v-model="formtest.map.provincia"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Regione" class="mt-0" v-model="formtest.map.regione"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Country" class="mt-0" v-model="formtest.map.country"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-text-field hide-details="auto" label="Peso in Kg" class="mt-0" v-model="formtest.weight" type="number"></v-text-field>
							</v-flex>
							<v-flex xs12 sm3 class="pl-4 pr-4">
								<v-btn color="primary" @click="testPay()"> Simula costo </v-btn>
							</v-flex>
						</v-layout>

						<!-- telefono: le tariffe simulate diventano card chiave/valore -->
						<div v-if="rates.length > 0 && mobileCards" class="kv-list px-3 pb-3">
							<key-value-card
								v-for="(rate, index) in rates"
								:key="index"
								:title="rate?.method?.trans?.[0]?.name || ''"
								:fields="[{ label: 'Prezzo', value: rate.price, strong: true }]"
							></key-value-card>
						</div>
						<v-simple-table key="table-branch-1" v-else-if="rates.length > 0">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Metodo</th>
										<th class="text-left">Prezzo</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(rate, index) in rates" :key="index">
										<td>
											{{ rate?.method?.trans?.[0]?.name }}
										</td>
										<td>
											{{ rate.price }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>

						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="shipcost-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="nomeMetodo(item)" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Riepilogo e fasce'" @click="apri(item)">
														<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu" @click.stop>
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<ShippingCostDetail v-if="aperto(item)" :item="item" :metodo="nomeMetodo(item)" :pagina="items" @edit="editItem(item)" @delete="deleteItem(item)" />
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id">
											<td class="pl-1 pr-0 text-no-wrap" style="width: 76px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Riepilogo e fasce'" @click="apri(item)">
													<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td class="font-weight-medium">{{ nomeMetodo(item) }}</td>
											<td>
												<div class="d-flex align-center">
													<Bandiera :codice="item.country" class="mr-2" />
													<div>
														<div>{{ nomePaese(item.country) }}</div>
														<div class="sc-sub">{{ zona(item) }}</div>
													</div>
												</div>
											</td>
											<td class="text-no-wrap">{{ pesi(item.min, item.max) }}</td>
											<td class="text-no-wrap">{{ giorni(item.minday, item.maxday) }}</td>
											<td class="text-no-wrap font-weight-bold">{{ prezzo(item.price) }}</td>
										</tr>
										<tr v-if="aperto(item)" :key="item._id + '-detail'" class="sc-expanded">
											<td :colspan="headers.length" class="py-3">
												<ShippingCostDetail :item="item" :metodo="nomeMetodo(item)" :pagina="items" @edit="editItem(item)" @delete="deleteItem(item)" />
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando questa tariffa non potrai più ripristinarla: per quel peso e quella destinazione il metodo di spedizione non comparirà più.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogMassivo" max-width="360">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">Vengono eliminate tutte le fasce di {{ listinoFiltrato }}, non solo quelle della pagina. Non potrai più ripristinarle: per quella destinazione il metodo non comparirà più alla cassa.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogMassivo = false"> Annulla </v-btn>
					<v-btn color="error" text @click="confirmDeleteMassivo"> Elimina tutte </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createShippingCostsTourSteps, stopShippingCostsTour } from './shipping-costs-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ShippingCostDetail from '@/components/ecommerce/shippingcost/ShippingCostDetail.vue';
import Bandiera from '@/components/ecommerce/shippingcost/Bandiera.vue';
import { nomePaese, prezzo, giorni, pesi, zona } from '@/components/ecommerce/shippingcost/formato';
import isocodes from '../../utils/isocodecountry.json';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

const indirizzoVuoto = () => ({
	nome: '',
	street_number: '',
	route: '',
	locality: '', // citta
	comune: '', //comune
	provincia: '', //provincia
	regione: '', //regione
	country: '', //country
	postal_code: '',
	place_id: '',
});

export default {
	name: 'Costs',
	// pagina, righe, ordinamento e filtri stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { methods: 'array', country: 'array' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createShippingCostsTourSteps(), { onStop: stopShippingCostsTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
		ShippingCostDetail,
		Bandiera,
	},
	data() {
		return {
			methods: [],
			codes: isocodes,
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: { country: [], methods: [] },
				options: { sortBy: ['min'], sortDesc: [false], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			formtest: {
				address: '',
				weight: 0,
				map: indirizzoVuoto(),
			},
			total: 0,
			headers: [
				// colonna del menu a tre puntini e del dettaglio: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Metodo di spedizione', value: '_method' },
				{ text: 'Destinazione', value: 'country' },
				{ text: 'Peso', value: 'min' },
				{ text: 'Consegna', value: 'minday' },
				{ text: 'Prezzo', value: 'price' },
			],
			// tariffe con il dettaglio aperto (+)
			aperti: [],
			rates: [],
			dialogconfirm: false,
			daEliminare: null,
			dialogMassivo: false,
		};
	},
	async created() {
		this.listLoad();
		this.methods = (await this.fetchShipments()) || [];
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// i comandi massivi lavorano su un metodo solo verso un paese solo
		massivo() {
			return this.settings.filters.country.length === 1 && this.settings.filters.methods.length === 1;
		},
		// "Corriere X verso Italia", per i testi dei comandi massivi
		listinoFiltrato() {
			if (!this.massivo) return '';
			const metodo = this.methods.find(m => m._id === this.settings.filters.methods[0]);
			return `${(metodo && metodo.trans && metodo.trans.name) || 'metodo'} verso ${nomePaese(this.settings.filters.country[0])}`;
		},
		...mapGetters({
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',
			getItems: 'shippingcosts/getItems',
		}),
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'shippingcosts/asyncFetchData',
			destroyData: 'shippingcosts/destroyData',
			deleteCost: 'shippingcosts/delete',
			deleteShipment: 'shippingcosts/deleteShipment',
			searchAddress: 'googlemaps/searchAddress',
			fetchShipments: 'shippingmethods/select',
		}),
		// nome del metodo di spedizione della riga (stessa ricerca della tabella desktop)
		nomeMetodo(item) {
			return this.methods.find(el => el._id === item._method)?.trans?.name || '';
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Destinazione', value: `${nomePaese(item.country)} · ${zona(item)}` },
				{ label: 'Peso', value: pesi(item.min, item.max) },
				{ label: 'Consegna', value: giorni(item.minday, item.maxday) },
				{ label: 'Prezzo', value: prezzo(item.price), strong: true },
			];
		},
		nomePaese,
		prezzo,
		giorni,
		pesi,
		zona,
		aperto(item) {
			return this.aperti.includes(item._id);
		},
		apri(item) {
			this.aperti = this.aperto(item) ? this.aperti.filter(id => id !== item._id) : [...this.aperti, item._id];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		// inserimento, modifica, duplica e modifica massiva sono pagine: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.$router.push('/ecommerce/shipmentcost/new');
		},
		editItem(item) {
			this.$router.push(`/ecommerce/shipmentcost/${item._id}`);
		},
		filtriMassivi() {
			return { country: this.settings.filters.country[0], method: this.settings.filters.methods[0] };
		},
		duplica() {
			this.$router.push({ path: '/ecommerce/shipmentcost/duplicate', query: this.filtriMassivi() });
		},
		editcomplete() {
			this.$router.push({ path: '/ecommerce/shipmentcost/bulk-edit', query: this.filtriMassivi() });
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.deleteCost(this.daEliminare)
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
		// Elimina massivo: chiede conferma, poi cancella tutte le fasce del metodo verso il paese filtrati
		elimina() {
			this.dialogMassivo = true;
		},
		confirmDeleteMassivo() {
			this.dialogMassivo = false;
			if (!this.massivo) return;
			this.setPreload(true);
			this.deleteShipment({ filters: { country: [...this.settings.filters.country], methods: [...this.settings.filters.methods] } })
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => this.setPreload(false));
		},
		testPay() {
			const mancanti = [];
			if (this.formtest.weight === '') mancanti.push('peso');
			if (this.formtest.map.street_number === '') mancanti.push('numero civico');
			if (this.formtest.map.route === '') mancanti.push('strada');
			if (this.formtest.map.locality === '') mancanti.push('località');
			if (this.formtest.map.comune === '') mancanti.push('comune');
			if (this.formtest.map.provincia === '') mancanti.push('provincia');
			if (this.formtest.map.regione === '') mancanti.push('regione');
			if (this.formtest.map.country === '') mancanti.push('country');
			if (this.formtest.map.postal_code === '') mancanti.push('codice postale');

			if (mancanti.length) {
				this.notifica('error', 'Inserire ' + mancanti.join(', '));
				return;
			}

			this.setPreload(true);
			axios
				.post(`${this.getUrl}shippingcosts/rates`, this.formtest, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.rates = data.data;
				})
				.catch(err => {
					this.notifica('error', err.message);
					if (err.response && err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				})
				.finally(() => this.setPreload(false));
		},
		async tastAddress() {
			this.setPreload(true);
			const address = await this.searchAddress(this.formtest);
			if (!address) {
				this.notifica('error', 'Indirizzo non valido');
			}
			this.formtest.map = indirizzoVuoto();
			this.formtest.map.place_id = address?.place_id;
			if (address && address?.address_components) {
				for (let line of address.address_components) {
					if (line.types.includes('establishment')) this.formtest.map.nome = line.long_name;
					if (line.types.includes('street_number')) this.formtest.map.street_number = line.long_name;
					if (line.types.includes('route')) this.formtest.map.route = line.long_name;
					if (line.types.includes('locality')) this.formtest.map.locality = line.long_name;
					if (line.types.includes('administrative_area_level_3')) this.formtest.map.comune = line.long_name;
					if (line.types.includes('administrative_area_level_2')) this.formtest.map.provincia = line.short_name;
					if (line.types.includes('administrative_area_level_1')) this.formtest.map.regione = line.long_name;
					if (line.types.includes('country')) this.formtest.map.country = line.short_name;
					if (line.types.includes('postal_code')) this.formtest.map.postal_code = line.short_name;
				}
			}
			this.setPreload(false);
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>


<style scoped>
.sc-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.sc-expanded,
.sc-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.shipcost-cards,
.shipcost-cards tr {
	display: block;
	width: 100%;
}
.shipcost-cards tr,
.shipcost-cards tr:hover {
	background: transparent !important;
}
.shipcost-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.shipcost-cards tr:first-child td {
	padding-top: 12px !important;
}
.shipcost-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.shipcost-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
